import React from 'react';
import CheckboxGroup from '../CheckboxGroup';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';
import { copyFor, capitalization } from '../../copy/copy';

const GetUpdatesCheckbox = props => (
    <Field
        name={props.name || 'getUpdates'}
        defaultChecked={props.defaultChecked || true}
        component={CheckboxGroup}
        label={
            props.labelText ||
            copyFor('formFields', 'updates', undefined, capitalization.eachWord)
        }
        normalize={v => !!v}
    />
);

GetUpdatesCheckbox.propTypes = {
    labelText: PropTypes.string,
    name: PropTypes.string,
    defaultChecked: PropTypes.bool
};

export default GetUpdatesCheckbox;



// WEBPACK FOOTER //
// ./src/components/Widget/GetUpdatesCheckbox.jsx